import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card-actions.js'

const tagName = 'dap-ds-card-actions'

/**
 * `dap-ds-card-actions`
 * @summary A card actions is a container for actions in a card.
 * @element dap-ds-card-actions
 * @title - Card actions
 * @group card
 *
 * @property {'sm' | 'md' | 'lg'} size - The size of the card actions. Default is `sm`.
 * @property {'top' | 'bottom' | 'both' | 'none'} spacing - The spacing of the card actions. This adds a margin to the card actions. Default is `bottom`.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg").
 *
 * @slot - The content of the card actions.
 *
 * @csspart base - The main card actions container.
 *
 * @cssproperty --dds-card-actions-gap - The gap between items in the card actions. (default: var(--dds-spacing-200))
 * @cssproperty --dds-card-actions-padding-lg - The padding for large size card actions. (default: var(--dds-spacing-600))
 * @cssproperty --dds-card-actions-padding-md - The padding for medium size card actions. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-actions-padding-sm - The padding for small size card actions. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-actions-margin-lg - The margin for large size card actions spacing. (default: var(--dds-spacing-600))
 * @cssproperty --dds-card-actions-margin-md - The margin for medium size card actions spacing. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-actions-margin-sm - The margin for small size card actions spacing. (default: var(--dds-spacing-400))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCardActions',
})

export default reactWrapper
